import { useGetFavorites } from './hooks/use-get-favorites'

export const FavoritesProvider = () => {
  // load favorites at init to use them all around the app
  useGetFavorites()
  return null
}
